import { Truck, MapPin, Calendar, ClipboardCheck } from 'lucide-react'

export const LogisticsSection = () => {
  return (
    <div className="h-full flex flex-col animate-fade-in p-4">
      <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6 border-b-2 border-gray-400 pb-2">
        Coleta e Logística
      </h2>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="space-y-6">
          <p className="font-serif text-lg leading-relaxed">
            Entendemos que a remoção de sucata pode ser um desafio logístico.
            Por isso, o Banco da Sucata oferece um serviço completo de coleta
            programada para indústrias, demolições e grandes geradores.
          </p>

          <ul className="space-y-4">
            {[
              {
                icon: Truck,
                text: 'Frota diversificada (Munck, Roll-on, Caçambas)',
              },
              { icon: MapPin, text: 'Atendimento em toda a Grande São Paulo' },
              { icon: Calendar, text: 'Agendamento flexível (24h/7d)' },
              {
                icon: ClipboardCheck,
                text: 'Emissão de manifesto de transporte e certificado',
              },
            ].map((item, idx) => (
              <li
                key={idx}
                className="flex items-center gap-3 bg-white/50 p-2 retro-bevel-inset"
              >
                <item.icon className="w-6 h-6 text-blue-700" />
                <span className="font-serif font-medium">{item.text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="retro-bevel-outset p-2 bg-gray-300 h-full min-h-[200px] flex items-center justify-center">
          <img
            src="https://img.usecurling.com/p/500/400?q=industrial%20truck%20loading%20scrap"
            alt="Caminhão carregando"
            className="w-full h-full object-cover border-2 border-white"
          />
        </div>
      </div>
    </div>
  )
}
